import React from "react";
import imgLg from "../assets/about/lg.png";
import imgMd01 from "../assets/about/md-01.png";
import imgMd02 from "../assets/about/md-02.png";
import iPhone from "../assets/about/i-phone.svg";

function About() {
  return (
    <div>
      <div className=" mb-28 md:mt-8 md:mb-48  flex flex-col items-center justify-center">
        <div className="max-w-screen-lg px-4 md:px-8 flex flex-col items-center justify-center md:grid md:grid-cols-3 md:gap-8">
          <div className=" hidden md:block flex flex-col justify-center items-center md:col-span-1">
            <img src={imgLg} alt="" />
          </div>
          <div className="md:hidden mb-4 w-full grid grid-cols-2 gap-4 md:gap-8  ">
            <div className=" col-span-1">
              <img src={imgMd01} alt="" className="w-full" />
            </div>
            <div className=" col-span-1">
              <img src={imgMd02} alt="" className="w-full" />
            </div>
          </div>
          <div className=" md:col-span-2 flex flex-col  items-start">
            <h1 className="text-4xl lg:text-5xl font-semibold text-myBlue mb-4 lg:mb-8">
              About us
            </h1>
            <p className="text-sm lg:text-base font-extralight opacity-45 text-justify mb-4">
              Two friends, both passionate medical students and alumni of
              Dharmaraja College, Kandy, launched this journey back in 2021.
              What began as a small initiative to support fellow students has
              grown into an online tutoring class that has consistently produced
              outstanding results. With a unique approach that combines thorough
              theory lessons and intensive practice paper classes, our goal is
              to make complex concepts accessible and engaging for all students.
            </p>
            <p className=" text-sm lg:text-base font-semibold opacity-75 text-justify">
              Since our start, we’ve had the privilege of helping numerous
              students achieve their dream of entering top universities,
              including medical faculties. Our commitment goes beyond simply
              covering the syllabus – we focus on building a strong foundational
              understanding to ensure students are well-prepared for academic
              success. With a friendly, supportive environment and a solid
              educational background, we’re here to guide you toward your goals.
            </p>

            <div className="hidden w-full sm:w-auto flex flex-wrap flex-row mt-8  border p-2 rounded-xl">
              <div className="flex flex-row items-center space-x-3 p-4">
                <img src={iPhone} alt="" className="size-8 sm:size-auto" />
                <div className="flex flex-col">
                  <h2 className=" text-xs sm:text-base font-semibold opacity-50">
                    Janith Miyuranga
                  </h2>
                  <p className=" text-xl sm:text-2xl md:text-3xl font-semibold">
                    071 455 8616
                  </p>
                </div>
              </div>
              <div className="flex flex-row items-center space-x-3 p-4">
                <img src={iPhone} alt="" className="size-8 sm:size-auto" />
                <div className="flex flex-col">
                  <h2 className=" text-xs sm:text-base font-semibold opacity-50">
                    Nawod Dilshan
                  </h2>
                  <p className=" text-xl sm:text-2xl md:text-3xl font-semibold">
                    070 139 3986
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
